import IApplicationState from 'app/types/state';
import _ from 'lodash';

export function getCurrentForfeit(state: IApplicationState) {
  if (
    state.forfeits.forfeitsById !== undefined
    && state.forfeits.currentForfeitId !== undefined
  ) {
    const f = state.forfeits.forfeitsById[state.forfeits.currentForfeitId];
    if (!_.isEmpty(f)) {
      return {
        ...f,
        paymentEvent: {
          ...state.paymentEvents.paymentEventsById[f.fixtureMatch.id],
        },
        competition: {
          ...state.competitions.competitionsById[f.competition?.id],
        },
        fixtureMatch: {
          ...state.paymentEvents.paymentEventsById[f.fixtureMatch.id],
        },
      };
    }
  }
  return {};
}

export function getCurrentFormForfeit(state: IApplicationState) {
  return {
    ...getCurrentForfeit(state),
    ...state.forfeits.requestedData,
  };
}

export function getForfeits(state: IApplicationState) {
  return {
    ...state.forfeits,
    currentForfeit: {
      ...getCurrentForfeit(state),
    },
  };
}
